import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import routerSelectors from '@nocode-works/template/store/selectors/router'
import snackbarActions from '@nocode-works/template/store/modules/snackbar'

const usePaymentConfirmation = ({
  
} = {}) => {
  const params = useSelector(routerSelectors.params)
  const dispatch = useDispatch()
  useEffect(() => {
    if(params.changed_plan) {
      dispatch(snackbarActions.setSuccess('plan updated'))
    }
    else if(params.changed_card) {
      dispatch(snackbarActions.setSuccess('card updated'))
    }
  }, [
    params,
  ])
}

export default usePaymentConfirmation